// extracted by mini-css-extract-plugin
export default {"sidebar":"AccountSidebar_sidebar__NDpTb","link":"AccountSidebar_link__gmdIr","link__icon":"AccountSidebar_link__icon__DzDp+","link__text":"AccountSidebar_link__text__fDFo2"};